/** Current Host */
export const CURRENT_HOST = window.location.host;

/** Is Student */
export const isStudent = CURRENT_HOST === import.meta.env.VITE_STUDENT_URL;

/** Is Staff */
export const isStaff = CURRENT_HOST === import.meta.env.VITE_STAFF_URL;

/** Host Type */
export const hostType = isStudent ? "student" : isStaff ? "staff" : "";
